/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';

import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';

import { isTokenPresent } from '../utils/auth';
import Attribution from '../utils/Interface/Attribution';
import DocumentData from '../utils/Interface/DocumentData';
import apiRoutes from '../utils/hooks/apiRoutes';

import Header from '../components/Header';
import TableComplexe from '../components/TableComplexe';
import TableComplexeDocument from '../components/TableComplexeDocument';
import Menu from '../components/Menu';
import InputSelect from '../components/InputSelect';
import EditDocument from '../components/EditDocument';
import useSpecialToken from '../utils/hooks/useSpecialToken';
import EditAttribution from '../components/EditAttribution';


import '../style/css/dashboard.css';
import '../style/css/materials.css';

const Dashboard: React.FC = () => {

 
  const { userName, specialToken } = useSpecialToken();
  const [data, setData] = useState<Attribution[]>([]);
  const [dataDoc, setDataDoc] = useState<DocumentData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [basicModal, setBasicModal] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(null);
  const [attributionsFiltered, setAttributionsFiltered] = useState('');
  const [optXlModal, setOptXlModal] = useState(false);
  const [selectedAttributionId, setSelectedAttributionId] = useState<number | null>(null);
  const options2 = [
    { text: 'Tout voir', id: 0 },
    { text: '7 derniers jours', id: 1 },
    { text: 'Dernier mois', id: 2 },
    { text: 'Dernière année', id: 3 },
 
  ];
  const [selectedOption, setSelectedOption] = useState(options2[0].text);
  const [selectedOptionA, setSelectedOptionA] = useState(options2[0].text);

//useffect, fetch & filter data

  useEffect(() => {

    if (!isTokenPresent()) {
      // Si aucun token n'est présent, redirigez l'utilisateur vers la page de connexion
      window.location.href = '/'; // Redirection vers la page de connexion
    }

    if (!specialToken) {
      return; // Si specialToken est null ou non défini, ne rien faire
    }

    const fetchData = async () => {
      try {
        let headers: Record<string, string> = {
          'Content-Type': 'application/json'
        };
    
        if (specialToken) {

          headers['special-token'] = specialToken;

          const [attributionsResponse, documentsResponse] = await Promise.all([
          fetch(apiRoutes.attributionsGetAll, { headers }),
          fetch(apiRoutes.documentsGetAll, { headers })
        ]); 

        if (!attributionsResponse.ok || !documentsResponse.ok) {
          throw new Error('Erreur lors de la récupération des données');
        }
    
        const attributionsData = await attributionsResponse.json();
        const documentsData = await documentsResponse.json();
        console.log(attributionsData,"attributionsData")
    
        const filteredAttributions = filterAttributionData(attributionsData, selectedOption);
        const filteredDocuments = filterDocumentData(documentsData, selectedOptionA);
    
        setData(filteredAttributions);
        setDataDoc(filteredDocuments);
      
        } else {
          throw new Error('Special token is null or undefined');
        } 
    
      } catch (error) {
        console.error('Erreur lors de la récupération des données :', error);
      }
    };
    fetchData();
}, [selectedOption, selectedOptionA, specialToken]);


const filterAttributionData = (data: Attribution[], selectedOption: string): Attribution[] => {

  const now = new Date();
  let filteredAttributionData = data.filter(attribution => {
      return attribution.state !== undefined && attribution.state !== null &&
          !['document créé'].includes(attribution.state);
  });

  switch (selectedOption) {
      case '1':

          const sevenDaysAgo = new Date(now);
          sevenDaysAgo.setDate(now.getDate() - 7);

          return filteredAttributionData.filter(attribution => new Date(attribution.attribution_date) >= sevenDaysAgo);

      case '2':

          const lastMonth = new Date(now);
          lastMonth.setMonth(now.getMonth() - 1);

          return filteredAttributionData.filter(attribution => new Date(attribution.attribution_date) >= lastMonth);

      case '3':

          const lastYear = new Date(now);
          lastYear.setFullYear(now.getFullYear() - 1);
   
          return filteredAttributionData.filter(attribution => new Date(attribution.attribution_date) >= lastYear);

      case '0':
      default:

          return filteredAttributionData;
  }
};

  const filterDocumentData = (data: DocumentData[], selectedOption: string): DocumentData[] => {

    const now = new Date();

    let filteredDocumentData = data.filter(doc => {
        return doc.document_state !== undefined && doc.document_state !== null &&
            !['signé', 'envoyé'].includes(doc.document_state) && doc.is_deleted !== 1;
    });

    switch (selectedOption) {

        case '1':

            const sevenDaysAgo = new Date(now);
            sevenDaysAgo.setDate(now.getDate() - 7);
      
            return filteredDocumentData.filter(doc => new Date(doc.document_date) >= sevenDaysAgo);
            
        case '2':

            const lastMonth = new Date(now);
            lastMonth.setMonth(now.getMonth() - 1);
   
            return filteredDocumentData.filter(doc => new Date(doc.document_date) >= lastMonth);

        case '3':

            const lastYear = new Date(now);
            lastYear.setFullYear(now.getFullYear() - 1);
        
            return filteredDocumentData.filter(doc => new Date(doc.document_date) >= lastYear);

        case '0':
        default:

            return filteredDocumentData;
    }
};


// functions handle modal
  const toggleOpen = (id: number | null = null) => {
    setSelectedDocumentId(id);
    setBasicModal(!basicModal);
  };

  const toggleOpenxl = () => setOptXlModal(!optXlModal);

  // functions handle clis and events

  const handleEditClick = (attribution_id: number) => {
    setSelectedAttributionId(attribution_id);
    toggleOpenxl();
  };

  const handleCheckClick = (attribution_id: number, glpi_user_id: number) => {
    window.location.href = `inventaire/utilisateurs/${glpi_user_id}`;
  };

  const handleLignClick = (user_id: number) => {
    window.location.href = `inventaire/utilisateurs/${user_id}`;
  }

  const handleAttributionsFilterChange = (newValue: string) => {
    setSelectedOption(newValue);
    setAttributionsFiltered(newValue);
  };
  
  const handleDocumentsFilterChange = (newValue: string) => {
    setSelectedOptionA(newValue);

  };

  return (
    <div className="maindash">

      <div className="maindash__box1">
     
        <Header userName={userName} />

        <div className="maindash__box1__container">
      
          <h2 className="maindash__box1__container__title">DASHBOARD</h2>

          <div className='maindash__box1__container__table'>

            <div className='maindash__box1__container__table__1'>

              <h4 className='maindash__box1__container__table__1__title'>Attributions en attente de documents</h4>

              <div className='maindash__box1__container__table__1__inputselect'> 

                <InputSelect
                      selectedKey={4}
                      options={options2}
                      onChange={newValue => handleAttributionsFilterChange(String(newValue))} 
                      classValue={1} /> 

              </div>
        
              <div className='maindash__box1__container__table__1__div'>   

                <TableComplexe 
                attributions={data} 
                textaction='Modifier' 
                onClick={handleEditClick} 
                onCheckClick={handleCheckClick} />

                <div className='maindash__box1__container__table__1__div__modal'> 

                   <MDBModal 
                      open={optXlModal} 
                      tabIndex='3'
                      onClose={() => setOptXlModal(false)}>
                        <MDBModalDialog size='xl' className='modalxl'>
                          <MDBModalContent className='modalxl' id="contentm">
                            <MDBModalHeader>
                              <MDBModalTitle>Modifier une attribution</MDBModalTitle>
                              <MDBBtn className='btn-close' color='none' onClick={toggleOpenxl}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                              <EditAttribution 
                              attributionIdNumber={selectedAttributionId ||0} location={`/dashboard`} handleCancel={() => setOptXlModal(false)}/>
                           </MDBModalBody>
                          </MDBModalContent>
                        </MDBModalDialog>
                   </MDBModal>

                </div>

              </div>

            </div>   

            <div className='maindash__box1__container__table__2'>

              <h4 className='maindash__box1__container__table__2__title'>Documents en attente</h4>

              <div className='maindash__box1__container__table__2__inputselect'>

                <InputSelect 
                selectedKey={5}
                  options={options2} 
                  onChange={newValue => handleDocumentsFilterChange(String(newValue))} 
                  classValue={1} />

              </div>

              <TableComplexeDocument 
              documents={dataDoc} 
              textaction='Modifier' 
              onEdit={toggleOpen} 
              Present={1} 
              onLignClick={handleLignClick}
              response={true}/>

                <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-2'>
                  <MDBModalDialog>
                    <MDBModalContent id="contentl">
                      <MDBModalHeader>
                        <MDBModalTitle>Modifier un document</MDBModalTitle>
                        <MDBBtn className='btn-close' color='none' onClick={() => setBasicModal(false)}></MDBBtn>
                      </MDBModalHeader>
                      <MDBModalBody>
                        <EditDocument documentId={selectedDocumentId ?? 0} />
                      </MDBModalBody>
                      <MDBModalFooter>
                      </MDBModalFooter>
                    </MDBModalContent>
                  </MDBModalDialog>
                </MDBModal>
                
            </div>

          </div>

        </div>

      </div>

      <div className="maindash__menu">
        <Menu />
      </div>

    </div>
  );
}

export default Dashboard;
